import useMedia from '@src/hooks/useMedia';

export default function useIsLargeScreen() {
  return useMedia(['(min-width: 1024px)'], [true], false);
}
